/**
 *
 * 配置开发环境和线上环境之间的切换
 *
 * @param mscfUrl:接口域名地址
 * @param rootUrl:前台域名地址
 * @param adminUrl:后台域名地址
 * @param routerMode:路由模式
 * @param baseImgPath:图片存放地址
 *
 * @param  _AJAXURL:mscf地址
 * @param  _AJAXURL_cs:mscf测试地址
 * @param  _DOMAINURL:项目地址
 * @param  _WEBURL:项目前端地址
 * @param  _WEBURL_CS:项目前端测试地址
 * @param  _ROOT:根目录
 * @param  ORDERSTATUS:订单状态名称
 * @param  SERVICENAME:服务名称
 *"asset",//附件
 *"business_license",//营业执照
 * */

let [mscfUrl, routerMode, baseImgPath, rootUrl, adminUrl] = [
  '',
  'hash',
  '',
  '',
  ''
]
// 正式环境
const _AJAXURL = 'http://ycsb.mscf.gdychr.com'
const _DOMAINURL = 'http://admin.gdycsbt.com'
const _WEBURL = 'http://www.gdycsbt.com'
// 测试环境
const _AJAXURL_CS = 'http://ycsbcs.mscf.gdychr.com'
const _DOMAINURL_CS = 'http://csadmin.gdycsbt.com'
const _WEBURL_CS = 'http://cs.gdycsbt.com'

const UPLOADURL = 'http://admin.gdycsbt.com'

// const _AJAXURL_CS = 'http://ycsb.mscf.gdychr.com'
// const _DOMAINURL_CS = 'http://admin.gdycsbt.com'
// const _WEBURL_CS = 'http://www.gdycsbt.com'

// 最后的接口域名，如果域名是测试域名就使用测试的地址
var last_AJAXURL = _AJAXURL
var last_WEBURL = _WEBURL
var last_DOMAINURL = _DOMAINURL
// 当前环境 1、正式、2、测试
var rootType = 1
if (
  document.domain.indexOf('cs.gdycsbt') > -1 ||
  document.domain.indexOf('localhost1') > -1
) {
  last_AJAXURL = _AJAXURL_CS
  last_WEBURL = _WEBURL_CS
  last_DOMAINURL = _DOMAINURL_CS
  rootType = 2
}

if (process.env.NODE_ENV == 'development') {
  mscfUrl = last_AJAXURL + '/api/'
  baseImgPath = last_DOMAINURL + '/upload/'
  rootUrl = last_WEBURL
  adminUrl = last_DOMAINURL
} else {
  mscfUrl = last_AJAXURL + '/api/'
  baseImgPath = last_DOMAINURL + '/upload/'
  rootUrl = last_WEBURL
  adminUrl = last_DOMAINURL
}

export { mscfUrl, routerMode, baseImgPath, rootUrl, adminUrl, rootType, UPLOADURL}



// WEBPACK FOOTER //
// ./src/config/env.js